import * as yup from 'yup'

export default class BoolSchema extends yup.bool {
  mustTrue(msg: string) {
    return this.test({
      name: 'mustTrue',
      exclusive: true,
      message: msg || 'Debes aceptar',
      test: (value) => value === true,
    })
  }
}
